// Helper function to load blog post data
export interface BlogPostMetadata {
  id: number;
  title: string;
  date: string;
  category: string;
  excerpt: string;
}

export interface BlogPost extends BlogPostMetadata {
  content: any[];
}

// Load all blog post metadata (for listing page)
export async function loadAllPosts(): Promise<BlogPostMetadata[]> {
  const response = await fetch('/data/posts/index.json');
  if (!response.ok) {
    throw new Error('Failed to load blog posts');
  }
  return response.json();
}

// Load a single blog post by ID
export async function loadPostById(id: number): Promise<BlogPost> {
  const response = await fetch(`/data/posts/${id}.json`);
  if (!response.ok) {
    throw new Error(`Failed to load blog post ${id}`);
  }
  return response.json();
}

